export default {
  LOGIN: 'auth/name',
  LOGOUT: 'auth/logout',
  GET_USER_PROFILE: 'auth/getUserProfile',
  TOKEN_EXPIRE: 'auth/TokenExpire',
  CAPTCHA: 'auth/captcha',
  GET_CHG_PWD_CODE: 'auth/getChgPwdCode', // 获取修改密码用验证码
  UPDATE_PWD_BY_MOBILE: 'auth/updatePwdByMobile', // 根据用户名和手机号码修改密码的接口
  // new sys auth start
  FIND_SYS_AUTH: 'api/sysAuth/findSysAuth',
  FIND_COMP_AUTH: 'api/compAuth/findCompAuth',
  FIND_PROJ_AUTH: 'api/bizAuth/findProjAuth',
  FIND_SYS_COMP_USER_DD_LIST: 'api/sys/compUser/findCompUserDDList',
  FIND_SYS_FRONTEND_DD_LIST: 'api/sys/sysFrontend/findSysFrontendDDList',
  // new sys auth end
  FIND_SYS_VERSION_BY_APPLICATION_TYPE: 'api/sys/version/findSysVersionByApplicationType',
  // ...
  // UPLOAD_IMAGE: 'api/fileupload/image',
  GET_COMP_PROJ_MENU_TREE: 'api/admin/projauth/getCompProjMenuTree',
  GET_COMP_PROJ_MENU_SUB_NODE: 'api/admin/projauth/getCompProjMenuSubNode',
  GET_COMP_PROJ_MENU_SETTLE_ENTITY_LIST: 'api/admin/projauth/getCompProjMenuSettleEntityList',
  GET_COMP_PROJ_MENU_ENTITY_LIST: 'api/admin/projauth/getCompProjMenuEntityList',
  FIND_SYS_COMPANY_DD_LIST: 'api/sys/company/findSysCompanyDDList',
  // ##############################
  // rsp_ctr_acct
  INSERT_RSP_CTR_ACCT: 'api/proj/user/ctracct/insertRspCtrAcct',
  UPDATE_RSP_CTR_ACCT: 'api/proj/user/ctracct/updateRspCtrAcct',
  REMOVE_RSP_CTR_ACCT: 'api/proj/user/ctracct/removeRspCtrAcct',
  FIND_RSP_CTR_ACCT: 'api/proj/user/ctracct/findRspCtrAcct',
  FIND_RSP_CTR_ACCT_CONDITION: 'api/proj/user/ctracct/findRspCtrAcctCondition',
  FIND_RSP_CTR_ACCT_DD_LIST: 'api/proj/user/ctracct/findRspCtrAcctDDList',
  // rsp_cost_column
  FIND_RSP_COST_COLUMN_DD_LIST: 'api/proj/conf/costcolumn/findRspCostColumnDDList',
  // rsp_fee_name
  FIND_RSP_FEE_NAME_DD_LIST: 'api/proj/conf/feename/findRspFeeNameDDList',
  // rsp_project
  INSERT_RSP_PROJECT: 'api/proj/project/project/insertRspProject',
  UPDATE_RSP_PROJECT: 'api/proj/project/project/updateRspProject',
  REMOVE_RSP_PROJECT: 'api/proj/project/project/removeRspProject',
  FIND_RSP_PROJECT: 'api/proj/project/project/findRspProject',
  FIND_RSP_PROJECT_CONDITION: 'api/proj/project/project/findRspProjectCondition',
  UPDATE_RSP_PROJECT_MGR: 'api/proj/project/project/updateRspProjectMgr',
  BUILD_PROJECT: 'api/proj/project/project/buildProject',
  BUILD_DEMO_PROJECT: 'api/proj/project/project/buildDemoProject',
  UPDATE_RSP_PROJECT_SETTLE_DT_NUM: 'api/proj/project/project/updateRspProjectSettleDtNum',
  UPDATE_RSP_PROJ_DEF_SURCHARGE_TAX_RATE: 'api/proj/project/project/updateRspProjDefSurchargeTaxRate',
  UPDATE_RSP_PROJECT_PERCENT: 'api/proj/project/project/updateRspProjectPercent',
  FIND_COMP_PROJ_DD_LIST: 'api/proj/project/project/findCompProjDDList',
  FIND_COMP_PROJ_DD_LIST_WITH_MORE: 'api/proj/project/project/findCompProjDDListWithMore',
  FIND_PROJ_POSITION_DD_LIST: 'api/sys/projPosition/findProjPositionDDList',
  // rsp_project_user
  FIND_PROJECT_USER_CONDITION: 'api/proj/conf/projuser/findProjectUserCondition',
  FIND_PROJECT_USER: 'api/proj/conf/projuser/findProjectUser',
  ASSIGN_PROJECT_USER: 'api/proj/conf/projuser/assignProjectUser',
  // rsp_proj_assign
  ASSIGN_RSP_PROJECT_ACCOUNTANT: 'api/proj/project/projassign/assignRspProjectAccountant',
  ASSIGN_RSP_PROJECT_CASHIER: 'api/proj/project/projassign/assignRspProjectCashier',
  ASSIGN_RSP_PROJECT_CHECKER: 'api/proj/project/projassign/assignRspProjectChecker',
  ASSIGN_RSP_PROJECT_OTH_USER: 'api/proj/project/projassign/assignRspProjectOthUser',
  ASSIGN_RSP_PROJECT_COST_CTRL_USER: 'api/proj/project/projassign/assignRspProjectCostCtrlUser',
  FIND_RSP_PROJECT_ASSIGN_FINANCE: 'api/proj/project/projassign/findRspProjAssignFinance',
  // rsp_proj_ctr_acct
  INSERT_RSP_PROJ_CTR_ACCT: 'api/proj/project/projctracct/insertRspProjCtrAcct',
  UPDATE_RSP_PROJ_CTR_ACCT: 'api/proj/project/projctracct/updateRspProjCtrAcct',
  REMOVE_RSP_PROJ_CTR_ACCT: 'api/proj/project/projctracct/removeRspProjCtrAcct',
  FIND_RSP_PROJ_CTR_ACCT_LIST: 'api/proj/project/projctracct/findRspProjCtrAcctList',
  FIND_RSP_PROJ_CTR_ACCT_DD_LIST: 'api/proj/project/projctracct/findRspProjCtrAcctDDList',
  // trans_util
  FIND_PROJ_SETTLE_DT_NUM_DD_LIST: 'api/proj/project/util/findProjSettleDtNumDDList', // no need
  FIND_PROJ_TRANS_DOC_MONTH_INDEX_LIST: 'api/proj/project/util/findProjTransDocMonthIndexList',
  // entryStatisticManage
  DOWNLOAD_RSP_PROJ_STATISTIC: 'api/proj/project/projstatistic/downloadRspProjStatistic',
  // entryProjectDownload
  PROJECT_GENERATE: 'api/proj/project/download/generateSelectedExcel',
  PROJECT_FIND_DOWNLOAD_HIST_LIST_RECENT: 'api/proj/project/download/findDownloadHistListRecent',
  PROJECT_DOWNLOAD_FILE: 'api/proj/project/download/downloadFile',
  // rsp_proj_settle_entity
  INSERT_RSP_PROJ_SETTLE_ENTITY: 'api/proj/project/projsettleentity/insertRspProjSettleEntity',
  UPDATE_RSP_PROJ_SETTLE_ENTITY_KEY_INFO: 'api/proj/project/projsettleentity/updateRspProjSettleEntityKeyInfo',
  UPDATE_RSP_PROJ_SETTLE_ENTITY: 'api/proj/project/projsettleentity/updateRspProjSettleEntity',
  REMOVE_RSP_PROJ_SETTLE_ENTITY: 'api/proj/project/projsettleentity/removeRspProjSettleEntity',
  FIND_RSP_PROJ_SETTLE_ENTITY: 'api/proj/project/projsettleentity/findRspProjSettleEntity',
  FIND_RSP_PROJ_SETTLE_ENTITY_LIST: 'api/proj/project/projsettleentity/findRspProjSettleEntityList',
  FIND_RSP_PROJ_SETTLE_ENTITY_STATISTIC_LIST: 'api/proj/project/projsettleentity/findRspProjSettleEntityStatisticList',
  // rsp_proj_settle_trans
  INSERT_RSP_PROJ_SETTLE_TRANS: 'api/proj/project/projsettletrans/insertRspProjSettleTrans',
  UPDATE_RSP_PROJ_SETTLE_TRANS: 'api/proj/project/projsettletrans/updateRspProjSettleTrans',
  REMOVE_RSP_PROJ_SETTLE_TRANS: 'api/proj/project/projsettletrans/removeRspProjSettleTrans',
  UPDATE_RSP_PROJ_SETTLE_TRANS_DOC_INDEX: 'api/proj/project/projsettletrans/updateRspProjSettleTransDocIndex',
  // FIND_RSP_PROJ_SETTLE_TRANS: 'api/proj/project/projsettletrans/findRspProjSettleTrans',
  FIND_RSP_PROJ_SETTLE_TRANS_LIST: 'api/proj/project/projsettletrans/findRspProjSettleTransList',
  FIND_RSP_PROJ_SETTLE_TRANS_LIST_BY_FEEID: 'api/proj/project/projsettletrans/findRspProjSettleTransListByFeeId',
  DOWNLOAD_RSP_PROJ_SETTLE_TRANS_LIST: 'api/proj/project/projsettletrans/downloadRspProjSettleTransList',
  DOWNLOAD_RSP_PROJ_SETTLE_TRANS_LIST_BY_FEE_ID: 'api/proj/project/projsettletrans/downloadRspProjSettleTransListByFeeId',
  CHECK_RSP_PROJ_SETTLE_TRANS: 'api/proj/project/projsettletrans/checkRspProjSettleTrans',
  // rsp_payment
  INSERT_RSP_PROJ_SETTLE_PAYMENT: 'api/proj/conf/payment/insertRspPayment',
  UPDATE_RSP_PROJ_SETTLE_PAYMENT: 'api/proj/conf/payment/updateRspPayment',
  REMOVE_RSP_PROJ_SETTLE_PAYMENT: 'api/proj/conf/payment/removeRspPayment',
  FIND_RSP_PROJ_SETTLE_PAYMENT_LIST: 'api/proj/conf/payment/findRspPaymentList',
  FIND_RSP_PROJ_SETTLE_PAYMENT_DD_LIST: 'api/proj/conf/payment/findRspPaymentDDList',
  // rsp_proj_income_entity
  INSERT_RSP_PROJ_INCOME_ENTITY: 'api/proj/project/projincomeentity/insertRspProjIncomeEntity',
  UPDATE_RSP_PROJ_INCOME_ENTITY_KEY_INFO: 'api/proj/project/projincomeentity/updateRspProjIncomeEntityKeyInfo',
  UPDATE_RSP_PROJ_INCOME_ENTITY: 'api/proj/project/projincomeentity/updateRspProjIncomeEntity',
  REMOVE_RSP_PROJ_INCOME_ENTITY: 'api/proj/project/projincomeentity/removeRspProjIncomeEntity',
  FIND_RSP_PROJ_INCOME_ENTITY: 'api/proj/project/projincomeentity/findRspProjIncomeEntity',
  FIND_RSP_PROJ_INCOME_ENTITY_LIST: 'api/proj/project/projincomeentity/findRspProjIncomeEntityList',
  FIND_RSP_PROJ_INCOME_ENTITY_STATISTIC_LIST: 'api/proj/project/projincomeentity/findRspProjIncomeEntityStatisticList',
  // rsp_proj_income_trans
  INSERT_RSP_PROJ_INCOME_TRANS: 'api/proj/project/projincometrans/insertRspProjIncomeTrans',
  UPDATE_RSP_PROJ_INCOME_TRANS: 'api/proj/project/projincometrans/updateRspProjIncomeTrans',
  REMOVE_RSP_PROJ_INCOME_TRANS: 'api/proj/project/projincometrans/removeRspProjIncomeTrans',
  UPDATE_RSP_PROJ_INCOME_TRANS_DOC_INDEX: 'api/proj/project/projincometrans/updateRspProjIncomeTransDocIndex',
  // FIND_RSP_PROJ_INCOME_TRANS: 'api/proj/project/projincometrans/findRspProjIncomeTrans',
  FIND_RSP_PROJ_INCOME_TRANS_LIST: 'api/proj/project/projincometrans/findRspProjIncomeTransList',
  DOWNLOAD_RSP_PROJ_INCOME_TRANS_LIST: 'api/proj/project/projincometrans/downloadRspProjIncomeTransList',
  CHECK_RSP_PROJ_INCOME_TRANS: 'api/proj/project/projincometrans/checkRspProjIncomeTrans',
  // rsp_proj_acct_pay_entity
  INSERT_RSP_PROJ_ACCT_PAY_ENTITY: 'api/proj/project/projacctpayentity/insertRspProjAcctPayEntity',
  UPDATE_RSP_PROJ_ACCT_PAY_ENTITY_KEY_INFO: 'api/proj/project/projacctpayentity/updateRspProjAcctPayEntityKeyInfo',
  UPDATE_RSP_PROJ_ACCT_PAY_ENTITY: 'api/proj/project/projacctpayentity/updateRspProjAcctPayEntity',
  REMOVE_RSP_PROJ_ACCT_PAY_ENTITY: 'api/proj/project/projacctpayentity/removeRspProjAcctPayEntity',
  FIND_RSP_PROJ_ACCT_PAY_ENTITY: 'api/proj/project/projacctpayentity/findRspProjAcctPayEntity',
  FIND_RSP_PROJ_ACCT_PAY_ENTITY_LIST: 'api/proj/project/projacctpayentity/findRspProjAcctPayEntityList',
  FIND_RSP_PROJ_ACCT_PAY_ENTITY_STATISTIC_LIST: 'api/proj/project/projacctpayentity/findRspProjAcctPayEntityStatisticList',
  // rsp_proj_acct_pay_trans
  INSERT_RSP_PROJ_ACCT_PAY_TRANS: 'api/proj/project/projacctpaytrans/insertRspProjAcctPayTrans',
  UPDATE_RSP_PROJ_ACCT_PAY_TRANS: 'api/proj/project/projacctpaytrans/updateRspProjAcctPayTrans',
  REMOVE_RSP_PROJ_ACCT_PAY_TRANS: 'api/proj/project/projacctpaytrans/removeRspProjAcctPayTrans',
  UPDATE_RSP_PROJ_ACCT_PAY_TRANS_DOC_INDEX: 'api/proj/project/projacctpaytrans/updateRspProjAcctPayTransDocIndex',
  // FIND_RSP_PROJ_ACCT_PAY_TRANS: 'api/proj/project/projacctpaytrans/findRspProjAcctPayTrans',
  FIND_RSP_PROJ_ACCT_PAY_TRANS_LIST: 'api/proj/project/projacctpaytrans/findRspProjAcctPayTransList',
  DOWNLOAD_RSP_PROJ_ACCT_PAY_TRANS_LIST: 'api/proj/project/projacctpaytrans/downloadRspProjAcctPayTransList',
  CHECK_RSP_PROJ_ACCT_PAY_TRANS: 'api/proj/project/projacctpaytrans/checkRspProjAcctPayTrans',
  // rsp_proj_acct_receive_entity
  INSERT_RSP_PROJ_ACCT_RECEIVE_ENTITY: 'api/proj/project/projacctreceiveentity/insertRspProjAcctReceiveEntity',
  UPDATE_RSP_PROJ_ACCT_RECEIVE_ENTITY_KEY_INFO: 'api/proj/project/projacctreceiveentity/updateRspProjAcctReceiveEntityKeyInfo',
  UPDATE_RSP_PROJ_ACCT_RECEIVE_ENTITY: 'api/proj/project/projacctreceiveentity/updateRspProjAcctReceiveEntity',
  REMOVE_RSP_PROJ_ACCT_RECEIVE_ENTITY: 'api/proj/project/projacctreceiveentity/removeRspProjAcctReceiveEntity',
  FIND_RSP_PROJ_ACCT_RECEIVE_ENTITY: 'api/proj/project/projacctreceiveentity/findRspProjAcctReceiveEntity',
  FIND_RSP_PROJ_ACCT_RECEIVE_ENTITY_LIST: 'api/proj/project/projacctreceiveentity/findRspProjAcctReceiveEntityList',
  FIND_RSP_PROJ_ACCT_RECEIVE_ENTITY_STATISTIC_LIST: 'api/proj/project/projacctreceiveentity/findRspProjAcctReceiveEntityStatisticList',
  // rsp_proj_acct_receive_trans
  INSERT_RSP_PROJ_ACCT_RECEIVE_TRANS: 'api/proj/project/projacctreceivetrans/insertRspProjAcctReceiveTrans',
  UPDATE_RSP_PROJ_ACCT_RECEIVE_TRANS: 'api/proj/project/projacctreceivetrans/updateRspProjAcctReceiveTrans',
  REMOVE_RSP_PROJ_ACCT_RECEIVE_TRANS: 'api/proj/project/projacctreceivetrans/removeRspProjAcctReceiveTrans',
  UPDATE_RSP_PROJ_ACCT_RECEIVE_TRANS_DOC_INDEX: 'api/proj/project/projacctreceivetrans/updateRspProjAcctReceiveTransDocIndex',
  // FIND_RSP_PROJ_ACCT_RECEIVE_TRANS: 'api/proj/project/projacctreceivetrans/findRspProjAcctReceiveTrans',
  FIND_RSP_PROJ_ACCT_RECEIVE_TRANS_LIST: 'api/proj/project/projacctreceivetrans/findRspProjAcctReceiveTransList',
  DOWNLOAD_RSP_PROJ_ACCT_RECEIVE_TRANS_LIST: 'api/proj/project/projacctreceivetrans/downloadRspProjAcctReceiveTransList',
  CHECK_RSP_PROJ_ACCT_RECEIVE_TRANS: 'api/proj/project/projacctreceivetrans/checkRspProjAcctReceiveTrans',
  // rsp_proj_acct_cur_entity
  INSERT_RSP_PROJ_ACCT_CUR_ENTITY: 'api/proj/project/projacctcurentity/insertRspProjAcctCurEntity',
  UPDATE_RSP_PROJ_ACCT_CUR_ENTITY_KEY_INFO: 'api/proj/project/projacctcurentity/updateRspProjAcctCurEntityKeyInfo',
  UPDATE_RSP_PROJ_ACCT_CUR_ENTITY: 'api/proj/project/projacctcurentity/updateRspProjAcctCurEntity',
  REMOVE_RSP_PROJ_ACCT_CUR_ENTITY: 'api/proj/project/projacctcurentity/removeRspProjAcctCurEntity',
  FIND_RSP_PROJ_ACCT_CUR_ENTITY: 'api/proj/project/projacctcurentity/findRspProjAcctCurEntity',
  FIND_RSP_PROJ_ACCT_CUR_ENTITY_LIST: 'api/proj/project/projacctcurentity/findRspProjAcctCurEntityList',
  FIND_RSP_PROJ_ACCT_CUR_ENTITY_STATISTIC_LIST: 'api/proj/project/projacctcurentity/findRspProjAcctCurEntityStatisticList',
  // rsp_proj_acct_cur_trans
  INSERT_RSP_PROJ_ACCT_CUR_TRANS: 'api/proj/project/projacctcurtrans/insertRspProjAcctCurTrans',
  UPDATE_RSP_PROJ_ACCT_CUR_TRANS: 'api/proj/project/projacctcurtrans/updateRspProjAcctCurTrans',
  REMOVE_RSP_PROJ_ACCT_CUR_TRANS: 'api/proj/project/projacctcurtrans/removeRspProjAcctCurTrans',
  UPDATE_RSP_PROJ_ACCT_CUR_TRANS_DOC_INDEX: 'api/proj/project/projacctcurtrans/updateRspProjAcctCurTransDocIndex',
  // FIND_RSP_PROJ_ACCT_CUR_TRANS: 'api/proj/project/projacctcurtrans/findRspProjAcctCurTrans',
  FIND_RSP_PROJ_ACCT_CUR_TRANS_LIST: 'api/proj/project/projacctcurtrans/findRspProjAcctCurTransList',
  DOWNLOAD_RSP_PROJ_ACCT_CUR_TRANS_LIST: 'api/proj/project/projacctcurtrans/downloadRspProjAcctCurTransList',
  CHECK_RSP_PROJ_ACCT_CUR_TRANS: 'api/proj/project/projacctcurtrans/checkRspProjAcctCurTrans',
  // rsp_proj_settle_invoice
  INSERT_RSP_PROJ_SETTLE_INVOICE: 'api/proj/project/projsettleinvoice/insertRspProjSettleInvoice',
  UPDATE_RSP_PROJ_SETTLE_INVOICE: 'api/proj/project/projsettleinvoice/updateRspProjSettleInvoice',
  REMOVE_RSP_PROJ_SETTLE_INVOICE: 'api/proj/project/projsettleinvoice/removeRspProjSettleInvoice',
  UPDATE_RSP_PROJ_SETTLE_INVOICE_CERT_INFO: 'api/proj/project/projsettleinvoice/updateRspProjSettleInvoiceCertInfo',
  // FIND_RSP_PROJ_SETTLE_INVOICE: 'api/proj/project/projsettleinvoice/findRspProjSettleInvoice',
  FIND_RSP_PROJ_SETTLE_INVOICE_LIST: 'api/proj/project/projsettleinvoice/findRspProjSettleInvoiceList',
  DOWNLOAD_RSP_PROJ_SETTLE_INVOICE_LIST: 'api/proj/project/projsettleinvoice/downloadRspProjSettleInvoiceList',
  FIND_RSP_PROJ_SETTLE_INVOICE_SUM: 'api/proj/project/projsettleinvoice/findRspProjSettleInvoiceSum',
  FIND_INV_NUMBER_LIST: 'api/proj/project/projsettleinvoice/findInvNumberList',
  FIND_INV_BILL_UNIT_LIST: 'api/proj/project/projsettleinvoice/findInvBillUnitList',
  // op_stat
  FIND_OP_STAT: 'api/proj/project/opstat/findOpStat',
  DOWNLOAD_OP_STAT: 'api/proj/project/opstat/downloadOpStat',
  UPDATE_OP_STAT_INFO: 'api/proj/project/opstat/updateOpStatInfo',
  UPDATE_OP_STAT_INCOME_ENTITY: 'api/proj/project/opstat/updateOpStatIncomeEntity',
  UPDATE_OP_STAT_FEE_ENTITY: 'api/proj/project/opstat/updateOpStatFeeEntity',
  UPDATE_OP_STAT_STORE_ENTITY: 'api/proj/project/opstat/updateOpStatStoreEntity',
  UPDATE_OP_STAT_TARGET_ENTITY: 'api/proj/project/opstat/updateOpStatTargetEntity',
  // fund_stat
  FIND_FUND_STAT: 'api/proj/project/fundstat/findFundStat',
  DOWNLOAD_FUND_STAT: 'api/proj/project/fundstat/downloadFundStat',
  FIND_FUND_STAT_ACCT_DD_LIST: 'api/proj/project/fundstat/findFundStatAcctDDList',
  UPDATE_FUND_STAT_INFO: 'api/proj/project/fundstat/updateFundStatInfo',
  UPDATE_FUND_STAT_ENTITY: 'api/proj/project/fundstat/updateFundStatEntity',
  // 损益表
  FIND_INCOME_STATEMENT: 'api/proj/rptv2/incomestatement/findIncomeStatement',
  DOWNLOAD_INCOME_STATEMENT: 'api/proj/rptv2/incomestatement/downloadIncomeStatement',
  FIND_COMP_INCOME_STATEMENT: 'api/proj/comprpt/compIncomeStatement/findCompIncomeStatement',
  DOWNLOAD_COMP_INCOME_STATEMENT: 'api/proj/comprpt/compIncomeStatement/downloadCompIncomeStatement',
  FIND_COMP_RPT_PROJ_LIST: 'api/proj/comprpt/compRptProjectMgmt/findCompRptProjList',
  SAVE_COMP_RPT_PROJ_LIST: 'api/proj/comprpt/compRptProjectMgmt/saveCompRptProjList',
  FIND_COMP_RPT_LAST_RPT_MONTH: 'api/proj/comprpt/compRptProjectMgmt/findCompRptLastRptMonth',
  // 资产负债表
  FIND_ASSET_DEBT: 'api/proj/rptv2/assetdebt/findAssetDebt',
  DOWNLOAD_ASSET_DEBT: 'api/proj/rptv2/assetdebt/downloadAssetDebt',
  FIND_ACCT_RECEIVE_DEPOSIT_LIST_GRP_BY_ENTITY_ID: 'api/proj/rptv2/assetdebt/findAcctReceiveDepositListGrpByEntityId',
  FIND_ACCT_PAY_SETTLE_COST_COL_ID_001007_LIST_GRP_BY_ENTITY_ID: 'api/proj/rptv2/assetdebt/findAcctPaySettleCostColId001007ListGrpByEntityId',
  FIND_COMP_ASSET_DEBT: 'api/proj/comprpt/compAssetDebt/findCompAssetDebt',
  DOWNLOAD_COMP_ASSET_DEBT: 'api/proj/comprpt/compAssetDebt/downloadCompAssetDebt',
  FIND_COMP_ACCT_RECEIVE_DEPOSIT_LIST_GRP_BY_ENTITY_ID: 'api/proj/comprpt/compAssetDebt/findCompAcctReceiveDepositListGrpByEntityId',
  FIND_COMP_ACCT_PAY_SETTLE_COST_COL_ID_001007_LIST_GRP_BY_ENTITY_ID: 'api/proj/comprpt/compAssetDebt/findCompAcctPaySettleCostColId001007ListGrpByEntityId',
  // 应收统计表
  FIND_COMP_ACCT_RECEIVE: 'api/proj/comprpt/compAcctReceive/findCompAcctReceive',
  DOWNLOAD_COMP_ACCT_RECEIVE: 'api/proj/comprpt/compAcctReceive/downloadCompAcctReceive',
  // 应付统计表
  FIND_COMP_ACCT_PAY: 'api/proj/comprpt/compAcctPay/findCompAcctPay',
  DOWNLOAD_COMP_ACCT_PAY: 'api/proj/comprpt/compAcctPay/downloadCompAcctPay',
  // accountant_trans
  FIND_ACCOUNTANT_TRANS_LIST: 'api/proj/project/accountanttrans/findAccountantTransList',
  // flow_trans
  FIND_TRANS_LIST_BY_PAYMENT: 'api/proj/project/flowtrans/findTransListByPayment',
  DOWNLOAD_TRANS_LIST_BY_PAYMENT: 'api/proj/project/flowtrans/downloadTransListByPayment',
  // rsp_proj_cashier_flow_entity
  INSERT_CASHIER_FLOW_ENTITY: 'api/proj/project/cashierflowentity/insertCashierFlowEntity',
  UPDATE_CASHIER_FLOW_ENTITY: 'api/proj/project/cashierflowentity/updateCashierFlowEntity',
  REMOVE_CASHIER_FLOW_ENTITY: 'api/proj/project/cashierflowentity/removeCashierFlowEntity',
  FIND_CASHIER_FLOW_ENTITY_LIST: 'api/proj/project/cashierflowentity/findCashierFlowEntityList',
  FIND_CASHIER_FLOW_ENTITY_DD_LIST: 'api/proj/project/cashierflowentity/findCashierFlowEntityDDList',
  // cashier_flow_trans
  INSERT_CASHIER_FLOW_TRANS: 'api/proj/project/cashierflowtrans/insertCashierFlowTrans',
  UPDATE_CASHIER_FLOW_TRANS: 'api/proj/project/cashierflowtrans/updateCashierFlowTrans',
  REMOVE_CASHIER_FLOW_TRANS: 'api/proj/project/cashierflowtrans/removeCashierFlowTrans',
  FIND_CASHIER_FLOW_TRANS_LIST: 'api/proj/project/cashierflowtrans/findCashierFlowTransList',
  DOWNLOAD_CASHIER_FLOW_TRANS_LIST: 'api/proj/project/cashierflowtrans/downloadCashierFlowTransList',
  // rsp_proj_acct_cur_trans
  INSERT_PROJ_MTH_RPT: 'api/proj/rpt/projmthrpt/insertProjMthRpt',
  UPDATE_PROJ_MTH_RPT: 'api/proj/rpt/projmthrpt/updateProjMthRpt',
  REMOVE_PROJ_MTH_RPT: 'api/proj/rpt/projmthrpt/removeProjMthRpt',
  FIND_PROJ_MTH_RPT_LIST: 'api/proj/rpt/projmthrpt/findProjMthRptList',
  GET_PROJ_MTH_RPT_CHECK_STATUS: 'api/proj/rpt/projmthrpt/getProjMthRptCheckStatus',
  UPDATE_PROJ_MTH_RPT_CHECK_STATUS: 'api/proj/rpt/projmthrpt/updateProjMthRptCheckStatus',
  SUBMIT_PROJ_MTH_RPT: 'api/proj/rpt/projmthrpt/submitProjMthRpt',
  APPROVAL_PROJ_MTH_RPT: 'api/proj/rpt/projmthrpt/approvalProjMthRpt',
  REJECT_PROJ_MTH_RPT: 'api/proj/rpt/projmthrpt/rejectProjMthRpt',
  REOPEN_PROJ_MTH_RPT: 'api/proj/rpt/projmthrpt/reopenProjMthRpt',
  FIND_PROJ_MTH_RPT_MSG_CONDITION: 'api/proj/rpt/projmthrpt/findProjMthRptMsgCondition',
  UPDATE_PROJ_MTH_RPT_MSG: '/api/proj/rpt/projmthrpt/updateProjMthRptMsg',
  // INSERT_PROJ_MTH_RPT_MSG: 'api/proj/rpt/projmthrpt/insertProjMthRptMsg',
  FIND_CASHIER_FLOW_FUND_STAT_ACCT: 'api/proj/project/cashierflowtrans/findCashierFlowFundStatAcct',
  // action_trail
  FIND_ACTION_TRAIL_LIST: 'api/audit/actiontrail/findActionTrailList',
  FIND_DATA_AUDIT_LIST_BY_ACTION_ID: 'api/audit/actiontrail/findDataAuditListByActionId',
  FIND_RECORD_HIST_DATA_AUDIT_LIST: 'api/audit/actiontrail/findRecordHistDataAuditList',
  FIND_SYS_LOG_SQL_LIST_BY_ACTION_ID: 'api/audit/actiontrail/findSysLogSqlListByActionId',
  // ...
  UPDATE_PWD_BY_OLDPWD: 'api/admin/safety/updatePwdByOldPwd', // 根据用户密码和验证码修改手机号码或邮箱
  // // 通用配置信息菜单相关接口
  // GET_CODE_LIST: 'api/admin/cmCode/getCodeList',
  // INSERT_CODE: 'api/admin/cmCode/insertCode',
  // GET_CODE_BY_ID: 'api/admin/cmCode/getCodeById',
  // UPDATE_CODE: 'api/admin/cmCode/updateCode',
  // DELETE_CODE: 'api/admin/cmCode/deleteCode',
  // REFRESH_COMMON_CODE_LIST: 'api/admin/cmCode/refreshCommonCodeList',
  // xxx
  FIND_PD_COST_COLUMN_DD_LIST: 'api/proj/conf/pdCostColumn/findPdCostColumnDDList',
  // 品名一级分类信息表 rsp_product_type_level_one
  INSERT_PD_TYPE_LEVEL_ONE: 'api/proj/conf/pdTypeLevelOne/insertPdTypeLevelOne',
  UPDATE_PD_TYPE_LEVEL_ONE: 'api/proj/conf/pdTypeLevelOne/updatePdTypeLevelOne',
  REMOVE_PD_TYPE_LEVEL_ONE: 'api/proj/conf/pdTypeLevelOne/removePdTypeLevelOne',
  FIND_PD_TYPE_LEVEL_ONE: 'api/proj/conf/pdTypeLevelOne/findPdTypeLevelOne',
  FIND_PD_TYPE_LEVEL_ONE_PAGE_LIST: 'api/proj/conf/pdTypeLevelOne/findPdTypeLevelOnePageList',
  FIND_PD_TYPE_LEVEL_ONE_DD_LIST: 'api/proj/conf/pdTypeLevelOne/findPdTypeLevelOneDDList',
  // 品名信息表 rsp_product_name
  INSERT_PD_NAME: 'api/proj/conf/pdName/insertPdName',
  UPDATE_PD_NAME: 'api/proj/conf/pdName/updatePdName',
  REMOVE_PD_NAME: 'api/proj/conf/pdName/removePdName',
  FIND_PD_NAME: 'api/proj/conf/pdName/findPdName',
  FIND_PD_NAME_PAGE_LIST: 'api/proj/conf/pdName/findPdNamePageList',
  FIND_PD_NAME_DD_LIST: 'api/proj/conf/pdName/findPdNameDDList',
  // 材料明细 rsp_proj_settle_material
  INSERT_RSP_PROJ_SETTLE_MATERIAL: 'api/proj/project/pdtrans/rspProjSettleMaterial/insertRspProjSettleMaterial',
  UPDATE_RSP_PROJ_SETTLE_MATERIAL: 'api/proj/project/pdtrans/rspProjSettleMaterial/updateRspProjSettleMaterial',
  REMOVE_RSP_PROJ_SETTLE_MATERIAL: 'api/proj/project/pdtrans/rspProjSettleMaterial/removeRspProjSettleMaterial',
  FIND_RSP_PROJ_SETTLE_MATERIAL: 'api/proj/project/pdtrans/rspProjSettleMaterial/findRspProjSettleMaterial',
  FIND_RSP_PROJ_SETTLE_MATERIAL_PAGE_LIST: 'api/proj/project/pdtrans/rspProjSettleMaterial/findRspProjSettleMaterialPageList',
  DOWNLOAD_RSP_PROJ_SETTLE_MATERIAL_LIST: 'api/proj/project/pdtrans/rspProjSettleMaterial/downloadRspProjSettleMaterialList',
  FIND_RSP_PROJ_SETTLE_MATERIAL_LIST_BY_TRANS_ID: 'api/proj/project/pdtrans/rspProjSettleMaterial/findRspProjSettleMaterialListByTransId',
  // FIND_RSP_PROJ_SETTLE_MATERIAL_LIST_BY_ENTITY_ID: 'api/proj/project/pdtrans/rspProjSettleMaterial/findRspProjSettleMaterialListByEntityId',
  FIND_RSP_PROJ_SETTLE_MATERIAL_SUMMARY_BY_ENTITY_ID: 'api/proj/project/pdtrans/rspProjSettleMaterial/findRspProjSettleMaterialSummaryByEntityId',
  // 劳务分包明细 rsp_proj_settle_labour
  INSERT_RSP_PROJ_SETTLE_LABOUR: 'api/proj/project/pdtrans/rspProjSettleLabour/insertRspProjSettleLabour',
  UPDATE_RSP_PROJ_SETTLE_LABOUR: 'api/proj/project/pdtrans/rspProjSettleLabour/updateRspProjSettleLabour',
  REMOVE_RSP_PROJ_SETTLE_LABOUR: 'api/proj/project/pdtrans/rspProjSettleLabour/removeRspProjSettleLabour',
  FIND_RSP_PROJ_SETTLE_LABOUR: 'api/proj/project/pdtrans/rspProjSettleLabour/findRspProjSettleLabour',
  FIND_RSP_PROJ_SETTLE_LABOUR_PAGE_LIST: 'api/proj/project/pdtrans/rspProjSettleLabour/findRspProjSettleLabourPageList',
  DOWNLOAD_RSP_PROJ_SETTLE_LABOUR_LIST: 'api/proj/project/pdtrans/rspProjSettleLabour/downloadRspProjSettleLabourList',
  FIND_RSP_PROJ_SETTLE_LABOUR_LIST_BY_TRANS_ID: 'api/proj/project/pdtrans/rspProjSettleLabour/findRspProjSettleLabourListByTransId',
  // FIND_RSP_PROJ_SETTLE_LABOUR_LIST_BY_ENTITY_ID: 'api/proj/project/pdtrans/rspProjSettleLabour/findRspProjSettleLabourListByEntityId',
  FIND_RSP_PROJ_SETTLE_LABOUR_SUMMARY_BY_ENTITY_ID: 'api/proj/project/pdtrans/rspProjSettleLabour/findRspProjSettleLabourSummaryByEntityId',
  // 专业分包明细 rsp_proj_settle_subcontract
  INSERT_RSP_PROJ_SETTLE_SUBCONTRACT: 'api/proj/project/pdtrans/rspProjSettleSubcontract/insertRspProjSettleSubcontract',
  UPDATE_RSP_PROJ_SETTLE_SUBCONTRACT: 'api/proj/project/pdtrans/rspProjSettleSubcontract/updateRspProjSettleSubcontract',
  REMOVE_RSP_PROJ_SETTLE_SUBCONTRACT: 'api/proj/project/pdtrans/rspProjSettleSubcontract/removeRspProjSettleSubcontract',
  FIND_RSP_PROJ_SETTLE_SUBCONTRACT: 'api/proj/project/pdtrans/rspProjSettleSubcontract/findRspProjSettleSubcontract',
  FIND_RSP_PROJ_SETTLE_SUBCONTRACT_PAGE_LIST: 'api/proj/project/pdtrans/rspProjSettleSubcontract/findRspProjSettleSubcontractPageList',
  DOWNLOAD_RSP_PROJ_SETTLE_SUBCONTRACT_LIST: 'api/proj/project/pdtrans/rspProjSettleSubcontract/downloadRspProjSettleSubcontractList',
  FIND_RSP_PROJ_SETTLE_SUBCONTRACT_LIST_BY_TRANS_ID: 'api/proj/project/pdtrans/rspProjSettleSubcontract/findRspProjSettleSubcontractListByTransId',
  // FIND_RSP_PROJ_SETTLE_SUBCONTRACT_LIST_BY_ENTITY_ID: 'api/proj/project/pdtrans/rspProjSettleSubcontract/findRspProjSettleSubcontractListByEntityId',
  FIND_RSP_PROJ_SETTLE_SUBCONTRACT_SUMMARY_BY_ENTITY_ID: 'api/proj/project/pdtrans/rspProjSettleSubcontract/findRspProjSettleSubcontractSummaryByEntityId',
  // 租赁明细 rsp_proj_settle_lease
  INSERT_RSP_PROJ_SETTLE_LEASE: 'api/proj/project/pdtrans/rspProjSettleLease/insertRspProjSettleLease',
  UPDATE_RSP_PROJ_SETTLE_LEASE: 'api/proj/project/pdtrans/rspProjSettleLease/updateRspProjSettleLease',
  REMOVE_RSP_PROJ_SETTLE_LEASE: 'api/proj/project/pdtrans/rspProjSettleLease/removeRspProjSettleLease',
  FIND_RSP_PROJ_SETTLE_LEASE: 'api/proj/project/pdtrans/rspProjSettleLease/findRspProjSettleLease',
  FIND_RSP_PROJ_SETTLE_LEASE_PAGE_LIST: 'api/proj/project/pdtrans/rspProjSettleLease/findRspProjSettleLeasePageList',
  DOWNLOAD_RSP_PROJ_SETTLE_LEASE_LIST: 'api/proj/project/pdtrans/rspProjSettleLease/downloadRspProjSettleLeaseList',
  FIND_RSP_PROJ_SETTLE_LEASE_LIST_BY_TRANS_ID: 'api/proj/project/pdtrans/rspProjSettleLease/findRspProjSettleLeaseListByTransId',
  // FIND_RSP_PROJ_SETTLE_LEASE_LIST_BY_ENTITY_ID: 'api/proj/project/pdtrans/rspProjSettleLease/findRspProjSettleLeaseListByEntityId',
  FIND_RSP_PROJ_SETTLE_LEASE_SUMMARY_BY_ENTITY_ID: 'api/proj/project/pdtrans/rspProjSettleLease/findRspProjSettleLeaseSummaryByEntityId',
  END: 'END'
}



// WEBPACK FOOTER //
// ./src/api/endpoints.js